import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export const tInput = "w-full bg-[#0A0A0A] border border-white/15 focus:border-white outline-none px-3 py-2.5 text-sm transition-colors";
export const tLabel = "font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40 block mb-1.5";
export const tBtn = "inline-flex items-center gap-2 bg-white text-black font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-white/85 transition-colors disabled:opacity-60";
export const tBtnGhost = "inline-flex items-center gap-2 border border-white/20 font-bold uppercase tracking-widest text-xs px-4 py-2.5 hover:bg-white hover:text-black transition-colors";

let _eventsCache = null;
export function useTrackEvents() {
  const [events, setEvents] = useState(_eventsCache || []);
  useEffect(() => {
    if (_eventsCache) return;
    api.get("/track/events").then(({ data }) => { _eventsCache = data; setEvents(data); }).catch(() => {});
  }, []);
  return events;
}

export function CsvImportButton({ endpoint, orgId, template, label, onDone, testid }) {
  const [busy, setBusy] = useState(false);
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const text = await file.text();
      const body = { csv: text };
      if (orgId) body.organization_id = orgId;
      const { data } = await api.post(endpoint, body);
      toast.success(`Imported ${data.created} row(s)${data.errors?.length ? `, ${data.errors.length} skipped` : ""}.`);
      if (data.errors?.length) console.warn("CSV import issues:", data.errors);
      onDone?.();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <label data-testid={testid} className={`${tBtnGhost} cursor-pointer`} title={template}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {label}
      <input type="file" accept=".csv,text/csv" onChange={onFile} className="hidden" disabled={busy} />
    </label>
  );
}
